import { INode } from 'shared/types/tree'
import { NodeType } from 'shared/types/ingestion'
import { updateTreeNode } from '../TreeRequests'

// This will return a shallow copy of the node (except for Notes, body is deep)
// replacing the current string content with the new string content
export function nodeForNewContentString(content: string, node: INode): INode {
  switch (node.type) {
    case NodeType.Note:
      return {
        ...node,
        body: {
          ...node.body,
          value: content,
        },
      }
    case NodeType.Question:
      return {
        ...node,
        description: content,
      }
    case NodeType.LessonPlan:
    case NodeType.Presentation:
    case NodeType.Activity:
    case NodeType.AttachmentsList:
      return {
        ...node,
        title: content,
      }
    default:
      return node
  }
}

export function updateNodeContent(content: string, node: INode) {
  switch (node.type) {
    case NodeType.Note:
      node.body!.value = content
      break
    case NodeType.Question:
      node.description = content
      break
    case NodeType.LessonPlan:
    case NodeType.Presentation:
    case NodeType.Activity:
    case NodeType.AttachmentsList:
      node.title = content
      break
    default:
      throw new Error(`dont know how to update node: ${node.type}`)
  }
}

export function contentFromNode(node: INode, doThrow: boolean = true) {
  switch (node.type) {
    case NodeType.Note:
      return node.body!.value
    case NodeType.Question:
      return node.description
    case NodeType.LessonPlan:
    case NodeType.Presentation:
    case NodeType.Activity:
    case NodeType.AttachmentsList:
      return node.title
    default:
      if (doThrow) {
        throw new Error(`How to deal with?: ${node.type}`)
      }
      return ''
  }
}

export function updateQuestionDescription(node: INode) {
  if (node.type !== NodeType.Question) {
    throw new Error('meant for question description updates only')
  }
  return updateTreeNode(node)
}
